export default __webpack_public_path__ + "static/media/book_bag.840ad382.png";